<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner
  bdColor="rgba(255,255,255,0.8)"
  size="large"
  color="#0058ff"
  type="ball-scale-pulse"
  [fullScreen]="true"
>
  <p style="color: black">กำลังโหลดข้อมูล...</p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">
  <div class="row">
    <div class="col-md-12" style="margin-left: 10px">
      <div class="card">
        <div class="card-header ui-sortable-handle no-print" style="cursor: move">
          <div class="card-tools">
          
            <ul class="nav nav-pills ml-auto">
              <li class="nav-item" style="float: left;">
              <a  (click)="Loadkpiall();"><button class="btn btn-sm btn-secondary">โหลดข้อมูลใหม่</button></a>  
              </li>
              <li class="nav-item">
                <a class="nav-link active" href="#allsum" data-toggle="tab"
                  >ภาพรวมนักส่งเสริม </a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#one" data-toggle="tab"
                  >ภาพรวมเขต </a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link " href="#two" data-toggle="tab"
                  >ภาพรวมส่วน</a
                >
              </li>
             
            </ul>
          </div>
        </div>
        <div class="card-body">
          <div class="tab-content p-0 no-print">
            <div class="chart tab-pane active" id="allsum">
              <div class="row">
                <div class="col-md-12">
                 <div class="input-group mb-3">
                  <span class="input-group-text" >เลือกงวด</span>
                  <select [(ngModel)]="date" class="form-select" (change)="Loadbydate();">
                    <option *ngFor="let item of selecttime" [ngValue]="[item.set,item.time]">{{item.time}}</option>
                  </select>
                   <span class="input-group-text" id="basic-addon1">เลือกนักส่งเสริม</span>
                   <select class="form-select"  [(ngModel)]="supporttercode">
                     <option  *ngFor="let item of supportterlist" [ngValue]="item.supcode">{{item.supcode +'|'+ item.supname}}</option>
                   </select>
                   <button class="btn btn-sm btn-primary" (click)="DatafilterBysupcode(1)">แสดง</button>
                 </div>
                </div>
              </div>  
             
           </div>
            <div class="chart tab-pane " id="one">
             <div class="row">
               <div class="col-md-12">
                <div class="input-group mb-3">
                  <span class="input-group-text" id="basic-addon1">เลือกงวด</span>
                  <select [(ngModel)]="date" class="form-select" (change)="Loadbydate();">
                    <option *ngFor="let item of selecttime" [ngValue]="[item.set,item.time]">{{item.time}}</option>
                  </select>
                  <span class="input-group-text" id="basic-addon1">เลือกเขต</span>
                  <select class="form-select"  [(ngModel)]="areacode">
                    <option  *ngFor="let item of arealist" [ngValue]="item.supzone">{{item.supname}}</option>
                  </select>
                  
                  <button class="btn btn-sm btn-primary" (click)="DatafilterBysupcode(2)">แสดง</button>
                </div>
               </div>
             </div>  

            </div>
            <div class="chart tab-pane " id="two">
              
              <div class="row">
                <div class="col-md-12">
                 <div class="input-group mb-3">
                  <span class="input-group-text" id="basic-addon1">เลือกงวด</span>
                  <select [(ngModel)]="date" class="form-select" (change)="Loadbydate();">
                    <option *ngFor="let item of selecttime" [ngValue]="[item.set,item.time]">{{item.time}}</option>
                  </select>
                   <span class="input-group-text" id="basic-addon1">เลือกส่วน</span>
                   <select class="form-select"  [(ngModel)]="partcode">
                     <option  *ngFor="let item of partlist" [ngValue]="item.Partcode">{{item.supname}}</option>
                   </select>
                  
                   <button class="btn btn-sm btn-primary" (click)="DatafilterBysupcode(3)">แสดง</button>
                 </div>
                </div>
              </div> 
            </div>
         
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="row" id="printlogo">
                  <div class="col-md-12 text-center" > 
                  <img src="./../../../../assets/images/bsflogo.png" style="width: 3%; height: auto;"/>&nbsp; &nbsp; <h3 id='hinder'>{{texttitle}}</h3>
                  <p class="text-bold">ชื่อ นักส่งเสริม : {{supname}}</p></div>
              </div>
          
               <h3 class="no-print">{{texttitle}}</h3>
              
               <div class="text-bold no-print" *ngIf="supname !='' ">
                <span style="float: left;">  ชื่อ นักส่งเสริม : {{supname}} </span> 
                <span style="float: right;">
                  <button class="btn btn-sm btn-primary no-print" (click)="ExportExcel();"> <i class="fas fa-download"></i> Download Excel</button>  &nbsp; &nbsp;&nbsp; &nbsp;
                  <button class="btn btn-sm btn-primary no-print" onclick="window.print()"><i class="fas fa-print"></i>  พิมพ์</button>
                </span>
               </div>
              <table class="table table-sm" #table>
                <thead class="table-secondary">
                  <tr class="text-center">
                    <th scope="col">ลำดับ</th>
                    <th scope="col">หัวข้อ</th>
                    <th scope="col">มาตรฐาน/คุณภาพ</th>
                    <th scope="col" colspan="4">เป้าหมายรวม</th>
                    <th scope="col" colspan="5">{{timework}}</th>
                  </tr>
                  <tr class="text-center">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>จำนวน</td>
                    <td>สะสม</td>
                    <td>หน่วย</td>
                    <td>% คุณภาพ</td>
                    <td>เป้าหมาย </td>
                    <td>ผลงาน</td>
                    <td>% ผลงาน</td>
                    <td>ตัวถ่วง 2</td>
                    <td>คะแนน </td>
                  </tr>
                </thead>
                <tbody class="text-bold">
                  <tr *ngFor="let item of defaltsets" >
                    <td>{{item.id}}</td> 
                    <td>{{item.topic}}</td>
                    <td>{{item.quality}}</td>
                    <td class="text-center">{{item.count | number}}</td>
                    <td class="text-center">{{item.collect | number}}</td>
                    <td class="text-center">{{item.perone}}</td>
                    <td class="text-center">{{item.persen  | number}} %</td>

                   
                  </tr>
                </tbody>
                <tbody id="topic1">
                  <tr>
                    <td colspan="3" class="text-bold table-secondary" *ngIf="mainbarrier != null">1.ยุทธศาสตร์การขยายพื้นที่ ({{mainbarrier[0].topic1}})</td>
                  </tr>
                  <tr *ngFor="let item of topic1" [ngClass]="[ item.perone === '+++รวม' ? 'table-secondary text-bold' : '' ]">
                    <td>{{item.id}}</td> 
                    <td>{{item.topic}}</td>
                    <td>{{item.quality}}</td>
                    <td class="text-center">{{item.count | number}}</td>
                    <td class="text-center">{{item.collect | number}}</td>
                    <td class="text-center">{{item.perone}}</td>
                    <td class="text-center">{{item.persen | number}}</td>

                    <td class="text-center">{{item.tg1 | number}}</td>
                    <td class="text-center">{{item.sc1 | number}}</td>
                    <td class="text-center">{{item.pc_tg1 | number}}</td>
                    <td class="text-center">{{item.brr1 | number}}</td>
                    <td class="text-center">{{item.score1  | number}} </td>
                  </tr>
                
                </tbody>
                <tbody id="topic2">
                  <tr>
                    <td colspan="3" class="text-bold table-secondary" *ngIf="mainbarrier != null">2.ยุทธศาสตร์การเพิ่มผลผลิต หนทางสู่เป้าหมายความต้องการของอ้อยผลผลิตสูงสุด ({{mainbarrier[0].topic2}})</td>
                  </tr>
                  <tr *ngFor="let item of topic2" [ngClass]="[ item.perone === '+++รวม' ? 'table-secondary text-bold' : '' ]">
                    <td>{{item.id}}</td> 
                    <td>{{item.topic}}</td>
                    <td>{{item.quality}}</td>
                    <td class="text-center">{{item.count | number}}</td>
                    <td class="text-center">{{item.collect | number}}</td>
                    <td class="text-center">{{item.perone}}</td>
                    <td class="text-center">{{item.persen | number}}</td>

                    <td class="text-center">{{item.tg1 | number}}</td>
                    <td class="text-center">{{item.sc1 | number}}</td>
                    <td class="text-center">{{item.pc_tg1 | number}}</td>
                    <td class="text-center">{{item.brr1 | number}}</td>
                    <td class="text-center">{{item.score1  | number}} </td>
                  </tr>
                </tbody>
                <tbody id="topic3">
                  <tr>
                    <td colspan="3" class="text-bold table-secondary"  *ngIf="mainbarrier != null">3.ยุทธศาสตร์การพัฒนายกระดับชาวไร่มืออาชีพ ({{mainbarrier[0].topic3}})</td>
                  </tr>
                  <tr *ngFor="let item of topic3" [ngClass]="[ item.perone === '+++รวม' ? 'table-secondary text-bold' : '' ]">
                    <td>{{item.id}}</td> 
                    <td>{{item.topic}}</td>
                    <td>{{item.quality}}</td>
                    <td class="text-center">{{item.count | number}}</td>
                    <td class="text-center">{{item.collect | number}}</td>
                    <td class="text-center">{{item.perone}}</td>
                    <td class="text-center">{{item.persen | number}}</td>

                    <td class="text-center">{{item.tg1 | number}}</td>
                    <td class="text-center">{{item.sc1 | number}}</td>
                    <td class="text-center">{{item.pc_tg1 | number}}</td>
                    <td class="text-center">{{item.brr1 | number}}</td>
                    <td class="text-center">{{item.score1  | number}} </td>
                  </tr>
                </tbody>
                <tbody id="topic4">
                  <tr>
                    <td colspan="3" class="text-bold table-secondary"  *ngIf="mainbarrier != null">4.ยุทธศาสตร์ยกระดับศักยภาพระบบบริหาร ({{mainbarrier[0].topic4}})</td>
                  </tr>
                  <tr *ngFor="let item of topic4" [ngClass]="[ item.perone === '+++รวม' || item.perone === '+++รวมคะแนน' ? 'table-secondary text-bold' : '' ]">
                    <td>{{item.id}}</td> 
                    <td>{{item.topic}}</td>
                    <td>{{item.quality}}</td>
                    <td class="text-center">{{item.count | number}}</td>
                    <td class="text-center">{{item.collect | number}}</td>
                    <td class="text-center">{{item.perone}}</td>
                    <td class="text-center">{{item.persen | number}}</td>

                    <td class="text-center">{{item.tg1 | number}}</td>
                    <td class="text-center">{{item.sc1 | number}}</td>
                    <td class="text-center">{{item.pc_tg1 | number}}</td>
                    <td class="text-center">{{item.brr1 | number}}</td>
                    <td class="text-center">{{item.score1  | number}} </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
          </div>
      
        </div>
      </div>

    
    </div>
  </div>
 
 
</div>
<app-footer></app-footer>
